<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="justify-center">Copy Travel Party To</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-card-title class="justify-center red--text font-weight-bold" v-if="items.length===0">Can't find bookings to copy travel party to</v-card-title>
                <v-text-field v-model="search" label="Search rental contract" single-line hide-details prepend-icon="mdi-magnify" v-if="items.length!==0"></v-text-field>
                <v-data-table 
                    :items="items" 
                    :items-per-page="10" 
                    :footer-props="{'items-per-page-options': [10]}"
                    :headers="headers"
                    :search="search"
                    :custom-filter="customSearch"
                    v-if="items.length!==0">
                    <template v-slot:item="props">
                        <tr>
                            <td>{{ props.item.huov_code }}</td>
                            <td>{{ props.item.huis_code }}</td>
                            <td>{{ props.item.huov_van_datum }}</td>
                            <td>{{ props.item.huov_tm_datum }}</td>
                            <td><v-btn class="primary" x-small v-on:click="copyTravelParty(props.item.huov_encrid)">Copy</v-btn></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer/>
                <v-btn class="primary" x-small v-on:click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        props: {
        },        
        data() {
            return {
                dialog: false,
                huov_encrid: "",
                search: "",
                headers: [
                    { text: "Booking", value: "huov_code", width: "20%"  },
                    { text: "Accommodation", value: "huis_code", width: "20%" },
                    { text: "Arrival", value: "huov_van_datum", width: "20%" },
                    { text: "Departure", value: "huov_tm_datum", width: "20%" },
                    { text: "", value: "", width: "20%" },
                ],
                items: [],
            }
        },
        methods: {
            openDialog(huov_encrid) {
                this.huov_encrid = huov_encrid;
                this.getRebookHouvs(huov_encrid);
                //console.log(huov_encrid);
                //this.dialog = true;
            },
            customSearch (value, search, item) {
                return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            getRebookHouvs(huov_encrid) {
                this.$axios.post("ares/json/ares/huov/getRebookHuovs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getRebookHuovs"
                    },
                    getRebookHuovs: {
                        huov_encrid: huov_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.items = res.data.getRebookHuovs;
                        this.dialog = true;
                    }
                });
            },
            copyTravelParty(to_huov_encrid) {
                this.$axios.post("ares/json/ares/huov/copyHogs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "copyHogs"
                    },
                    copyHogs: {
                        from_huov_encrid: this.huov_encrid,
                        to_huov_encrid: to_huov_encrid,
                    },
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.copyHogs.text,
                            color: res.data.copyHogs.color,
                        });
                        this.closeDialog();
                    }
                });
            },
            closeDialog() {
                this.dialog = false;
            }    
        }
    }
</script>

<style scoped>
</style>